/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_DataInputs */

const en_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const ar_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات`)
};

const bn_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেটা`)
};

const de_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten`)
};

const es_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos`)
};

const fr_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données`)
};

const pt_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados`)
};

const zh_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据`)
};

const tr_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri`)
};

const ru_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные`)
};

const pl_svcat_data = /** @type {(inputs: Svcat_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Svcat_DataInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_data = /** @type {((inputs?: Svcat_DataInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_DataInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_data(inputs)
	if (locale === "bn") return bn_svcat_data(inputs)
	if (locale === "de") return de_svcat_data(inputs)
	if (locale === "es") return es_svcat_data(inputs)
	if (locale === "fr") return fr_svcat_data(inputs)
	if (locale === "pt") return pt_svcat_data(inputs)
	if (locale === "zh") return zh_svcat_data(inputs)
	if (locale === "tr") return tr_svcat_data(inputs)
	if (locale === "ru") return ru_svcat_data(inputs)
	if (locale === "pl") return pl_svcat_data(inputs)
	return en_svcat_data(inputs)
});